import { Suspense, Fragment } from 'react';

import { ConversationListSection } from './conversation-list-section';
import { ConversationPanelSection } from './conversation-panel-section';
import { SecurityBanner } from './security-banner';

import { useChatConnection } from '@hooks/api/chat-websocket';
import { useChatPageLogic } from './chat.hook';
import type { TChatPageConfig } from './chat.types';
import * as S from './chat.styles';

const Chat = (props: TChatPageConfig) => {
  useChatConnection({ enabled: true });

  const {
    withoutConversationOrIsDesktop,
    withConversationOrIsDesktop,
    withoutConversationOnMobile,
  } = useChatPageLogic(props);

  return (
    <Suspense fallback={<Fragment />}>
      <S.ChatMain data-qa="chat-page" withoutBotPadding={withoutConversationOnMobile}>
        <SecurityBanner show={!withoutConversationOnMobile} />
        <S.ChatCard>
          <ConversationListSection show={withoutConversationOrIsDesktop} />
          <ConversationPanelSection show={withConversationOrIsDesktop} />
        </S.ChatCard>
      </S.ChatMain>
    </Suspense>
  );
};

Chat.displayName = 'Chat';
export { Chat };
